import styled from 'styled-components';

export const HealthStatusContainer = styled.div`
  display: flex;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
`;
